import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class StatuteOfLimitations  {
    _originalTypeClassName = "zERP.BO.StatuteOfLimitations";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
StatuteOfLimitations.translate = translateService;
}
this.EmployeePenalty = new Domain.EmployeePenalty();
this.Id = null;
this.Code = null;
this.Name = null;
this.LimitationStartDate = null;
this.LimitationDeactivationPeriod = null;
this.DeactivationReason = null;
this.LimitationTerminationDate = null;
this.Notes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
LimitationStartDate:any;
LimitationDeactivationPeriod:any;
DeactivationReason:any;
LimitationTerminationDate:any;
Notes:any;
EmployeePenalty:any;
static setEmployeePenalty = ($this, value) => {
var oldValue = $this.EmployeePenalty;
$this.EmployeePenalty = value;
if (value != null) {
if (oldValue != null && oldValue.StatuteOfLimitations != null) { oldValue.StatuteOfLimitations = null; }
if ($this.EmployeePenalty.StatuteOfLimitations !== $this) {
Domain.EmployeePenalty.setStatuteOfLimitations(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}